<template>
  <div class="box-second">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>培训考试</el-breadcrumb-item>
        <el-breadcrumb-item>课程管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary"  v-if="port==5||port==3" size="mini" class="add-user" @click="addRow">添加视频</el-button>
      <div style="display:flex;align-items:center">
          <span>视频名称：</span>
          <div style="width:10vw;margin-right:10px">
              <el-input placeholder="请输入视频名称" v-model="addForm.videoName"></el-input>
          </div>
            <!-- <span>视频类型：</span>
            <div style="width:10vw;margin-right:10px">
                <el-select v-model="useType" placeholder="请选择" clearable >
                        <el-option v-for="item in userTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </div> -->
           <el-button type="primary" icon="el-icon-search"  @click="doFilter">查询</el-button>
      </div>
      <span>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          v-if="port==5||port==3"
        >全选</el-checkbox>
        <el-button  v-if="port==5||port==3"  size="mini" type="primary" style="margin-left:1vw;" @click="configVideo">配置</el-button>
        <!-- <el-button  v-if="port==4"  size="mini" type="primary" style="margin-left:1vw;" @click="configVideo">配置</el-button> -->
      </span>
    </div>
    <div class="main">
      <div class="main-con">
        <el-checkbox-group   v-model="checkedVideo" @change="handleCheckedCitiesChange">
          <el-row :gutter="20">
            <el-col :span="8" v-for="item in videoList" :key="item.id">
              <div class="grid-content bg-color2">
                <p class="txt nowrap">{{item.videoName}}</p>
                <el-checkbox v-if="port==5||port==3"   :label="item.videoId" style="position: absolute;top: 2vh;"></el-checkbox>
                <!-- <img :src="item.videoCover" style="width:100%;height:50%;position: relative;" /> -->
                <video :src="item.videoUrl" style="width:100%;height:50%;position: relative;background:#000" controls="controls"></video>
                <p class="txt center nowrap">视频时长：{{item.videoLength}}分钟</p>
                <p class="txtArea line2">课程简介：{{item.course_introduce}}</p>
                <p class="ctl">
                  <span>排序：{{item.sort}}</span>
                  <span>
                    <el-button type="text" @click="editFun(item)">编辑</el-button>
                    <el-button type="text" style="color:#f00" @click="del(item)">删除</el-button>
                  </span>
                </p>
              </div>
            </el-col>
            <!-- <el-col :span="8"><div class="grid-content bg-color2"></div></el-col>
            <el-col :span="8"><div class="grid-content bg-color2"></div></el-col>-->
          </el-row>
        </el-checkbox-group>
      </div>
      <!-- 分页展示 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 5, 10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      ></el-pagination>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      width="500px"
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
    >
      <el-form :model="addForm2" label-width="120px" ref="ruleForm">
        <el-form-item label="课程名称：" prop="videoName" required>
          <el-input v-model="addForm2.videoName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="addForm2.sort"></el-input>
        </el-form-item>
        <el-form-item label="课程简介：">
          <el-input type="textarea" v-model="addForm2.courseIntroduce"></el-input>
        </el-form-item>
        <el-form-item label="封面图片：">
        <el-upload
          class="avatar-uploader video-avatar"
          v-bind:action="uploadphotoUrl"
          :headers="uploadHead"
          :data="uploadphotoData"
          :show-file-list="false"
          :on-success="handleIconSuccess2"
        >
          <img v-if="addForm2.videoCover !=''" :src="posterView2" class="avatar video-avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 企业下面的项目 -->
    <el-dialog
      title="配置项目"
      :visible.sync="proVis"
      center
      width="40%"
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
    >
      <div style="width:100%;height:60px;display:flex;align-items: center;align-content: center;">
        <span>项目名称：</span>
        <div style="width:30%;height:100%;display:flex;align-items: center;align-content: center;">
          <el-input placeholder="请输入项目名称" v-model="diaSearch.projectName"></el-input>
        </div>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="diaFilter"
          style="margin-left:10px;"
        >查询</el-button>
      </div>
      <div style="width:100%;height:60px;display:flex;align-items:center;align-content: center;">
        <span style="margin-right:10px">视频类型:</span>
        <el-select v-model="useType" placeholder="请选择">
          <el-option v-for="item in userTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <el-table :data="projects" height="400" border style="width: 100%">
        <!---@selection-change="handleSelectionChange"-->
        <el-table-column label width="55">
          <template scope="scope">
            <el-radio
              :label="scope.row"
              v-model="selProject"
              @change.native="getRadioRow(scope.$index,scope.row)"
            >{{''}}</el-radio>
          </template>
        </el-table-column>
        <!-- <el-table-column type="selection" width="80">
        </el-table-column>-->
        <el-table-column type="index" width="80" label="序号"></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proVis = false">取 消</el-button>
        <el-button type="primary" @click="toProjectFun">确 定</el-button>
      </div>
    </el-dialog>
            <!-- 新增窗口  添加视频 -->
        <el-dialog
          :title="dialogTitle"
          :visible.sync="addFormVisible1"
          center
          :append-to-body="true"
          :lock-scroll="false"
          class="add-form"
          width="500px"
        >
          <el-form
            :model="addForm1"
            ref="addForm1"
            label-width="100px"
            :label-position="labelPosition"
            :rules="rules"
          >
            <el-form-item label="名称：" prop="videoName">
              <el-input v-model="addForm1.videoName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="视频：">
              <el-upload
                class="avatar-uploader"
                v-bind:action="uploadUrl"
                v-bind:data="uploadData"
                v-bind:headers="uploadHead"
                v-bind:on-progress="uploadVideoProcess"
                v-bind:on-success="handleVideoSuccess"
                v-bind:before-upload="beforeUploadVideo"
                v-bind:show-file-list="false"
              >
                <video
                  v-if="videoForm.showVideoPath !='' && !videoFlag"
                  v-bind:src="videoForm.remark"
                  class="avatar video-avatar"
                  controls="controls"
                >您的浏览器不支持视频播放</video>
                <i
                  v-else-if="videoForm.showVideoPath =='' && !videoFlag"
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <el-progress
                  v-if="videoFlag == true"
                  type="circle"
                  v-bind:percentage="videoUploadPercent"
                  style="margin-top:7px;"
                ></el-progress>
              </el-upload>
            </el-form-item>
            <el-form-item label="视频封面">
              <el-upload
                class="avatar-uploader video-avatar"
                v-bind:action="uploadphotoUrl"
                :headers="uploadHead"
                :data="uploadphotoData"
                :show-file-list="false"
                :on-success="handleIconSuccess"
              >
                <img v-if="addForm1.videoCover !=''" :src="posterView" class="avatar video-avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancal()">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow1('addForm1')">确 定</el-button>
          </div>
        </el-dialog>
  </div>
</template>
<script>
import util from '../../untils/util'
import base from '../../untils/base'
import myHttp from '../../untils/port'

export default {
  data() {
    return {
      posterView2:'',
          labelPosition: 'right',
      groupId: '',
      port: '',
      dialogTitle: '', //弹出框名称
      addFormVisible: false,
      addForm: {
        videoGroupId: '',
        videoName: '',
        sort: '',
        courseIntroduce: '',
        business: '',
      },
      addForm2: {
        videoGroupId: '',
        videoName: '',
        sort: '',
        courseIntroduce: '',
        business: '',
        videoCover:''
      },
      addForm1: {
        videoId: '',
        videoUrl: '',
        videoCover: '',
        videoName: '',
        videoLength: '',
      },
      // uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
      // uploadHead:{
      //     accessToken:this.$store.state.token
      // },
      // icon:'',
      checkAll: false,
      isIndeterminate: false,
      checkedVideo: [],
      proVis: false, //配置项目弹出框
      selProject: {}, //选中的项目
      projects: [], //企业项目的项目
      diaSearch: {
        projectName: '',
        entId: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      videoList: [], //所有视频
      userTypes: [
        { name: '考试视频', id: '1' },
        { name: '通道视频', id: '2' },
      ], //使用类型
      useType:'',
      addFormVisible1:false,
            rules: {
        videoName: [
          { required: true, message: '请输入名称', trigger: 'change' },
        ],
      },
      ruleForm:{
        videoName: [
          { required: true, message: '请输入名称', trigger: 'change' },
        ],
      },
            videoFlag: false,
      //是否显示进度条
      videoUploadPercent: 0,
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
        showVideoPath: '', //封面地址
      },
      uploadUrl: myHttp.uploadVideo, //视频上传地址
      uploadphotoUrl:base.url+"/upload/uploadPhoto",
      uploadHead: {
        accessToken: util.session.get('token'),
      },
      uploadData: {
        uploadType: '218',
      },
      uploadphotoData: {
        type: '218',
      },
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.port = util.session.get('roleId') //4.项目端 5。企业端

    this.getData()
  },
  methods: {
    del(item){
      // console.log(item,'0000000000000000')
      let that = this
      this.$confirm('此操作将永久删除该视频文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteVideoGroup({
          videoGroupId:item.videoGropuId
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            that.getData()
          }else{
            this.$message({
              type:'error',
              message: res.data.msg
            }); 
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //获取视频数据
    getData(flag) {
      var that = this
      if(this.port==5||this.port==3){
          myHttp
        .getVideoEnt({
          entId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          videoName:this.addForm.videoName,
          useType:this.useType
        })
        .then(function (resp) {
          //console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].videoCover =
                list[i].videoCover && list[i].videoCover != ''
                  ? base.httpCtx + list[i].videoCover
                  : require('../../assets/image/v-cover.png')
              list[i].videoUrl =
                list[i].videoUrl && list[i].videoUrl != ''
                  ? base.httpCtx + list[i].videoUrl
                  : ''
            }
            that.videoList = list
            that.totalItems = resp.data.data.pageInfo.total || 0
          }
        })
      }else {
       myHttp.projectExamVideoProjectList({
          projectId: this.groupId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(function (resp) {
          //console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.examVideoProjectList.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].videoCover =
                list[i].videoCover && list[i].videoCover != ''
                  ? base.httpCtx + list[i].videoCover
                  : require('../../assets/image/v-cover.png')
              list[i].videoUrl =
                list[i].videoUrl && list[i].videoUrl != ''
                  ? base.httpCtx + list[i].videoUrl
                  : ''
            }
            that.videoList = list
            that.totalItems = resp.data.data.examVideoProjectList.total || 0
          }
        })
      }
    
    },
    //展示视频信息弹出框
    editFun(row) {
      console.log(row)
      this.addFormVisible = true
      this.addForm2.videoGroupId = row.videoGropuId
      this.addForm2.videoName = row.videoName
      this.addForm2.sort = row.sort
      this.addForm2.courseIntroduce = row.courseIntroduce || row.course_introduce
      this.addForm2.business = row.business
      this.addForm2.videoCover = row.videoCover
      this.posterView2 =  row.videoCover
    },
    //监听图片上传
    // handleIconSuccess(res, file) {
    //   this.icon = URL.createObjectURL(file.raw)
    //   this.form.icon = res.data.saveUrls
    // },
    //提交编辑信息
    sumbitAddRow(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this
          myHttp.editExamVideo(this.addForm2).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('编辑成功')
              that.getData()
              that.addFormVisible = false
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          return false
        }
      })
    },

    //全选
    handleCheckAllChange(val) {
      var all = []
      for (var i = 0; i < this.videoList.length; i++) {
        all.push(this.videoList[i].videoId)
      }
      this.checkedVideo = val ? all : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.videoList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.videoList.length
    },
    //配置项目
    configVideo() {
      // console.log(this.checkedVideo)
      if (this.checkedVideo.length == 0) {
        this.$message.error('请选择视频')
        return
      }
      this.selProject = {}
      this.proVis = true
      this.getProject()
    },
    //获取选中的项目
    handleSelectionChange(val) {
      this.selProject = val
    },
    //弹出框查询
    diaFilter() {
      this.getProject()
    },
    //获取项目
    getProject() {
      this.diaSearch.entId = this.groupId
      var that = this
      myHttp.getProEnt(this.diaSearch).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.projectList || []
          that.projects = list
        }
      })
    },
    //配置项目
    toProjectFun() {
      var that = this
      //console.log(this.selProject)
      // console.log(this.checkedVideo)
      if (this.selProject.length == 0) {
        this.$message.error('请选择项目')
        return
      }
      var videoIds = this.checkedVideo.join(',')
      var projectId = this.selProject.projectId
      myHttp
        .distributeEntVideo({
          videoIds: videoIds,
          projectId: projectId,
          distributeType: '1',
          entId: this.groupId,
          useType:'1'
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('操作成功')
            that.proVis = false
            that.selProject = {}
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //
    getRadioRow(index, row) {},
        // 新增数据
    addRow() {
      // console.log(this.addForm.videoId)
      this.videoForm.showVideoPath = ''
      //this.getDict()
      this.addForm.videoCover=''
      this.dialogTitle = '添加视频'
      ;(this.addFormVisible1 = true),
        (this.addForm1 = {
          videoId: '',
          videoUrl: '',
          videoCover: '',
          videoName: '',
          videoLength: '',
        })
    },
    // 将新增的数据添加到表格中
    sumbitAddRow1(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addForm1.videoId || this.addForm1.videoId == '') {
            this.addForm1.createBy = util.session.get('user').id
            this.addForm1.videoUrl = this.videoPath
            this.addForm1.videoLength = this.playTime
            this.addForm1.videoCover = this.poster
            this.addForm1.entId = this.groupId
            myHttp.uploadEntVideo(this.addForm1).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.addFormVisible1 = false
                that.currentPage = 1
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
            //console.log(this.addForm)
            this.addForm1.updateBy = util.session.get('user').id
            //this.addForm.videoId = this.addForm.videoId
            myHttp.updateVideo(this.addForm1).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.addFormVisible = false
                that.currentPage = 1
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
        //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 150
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov',
        ].indexOf(file.type) == -1
      ) {
        this.$message.msg('请上传正确的视频格式')
        return false
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过50MB')
        return false
      }
      this.isShowUploadVideo = false
    },
       //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true
      this.videoFlag = false
      this.videoUploadPercent = 0

      //后台上传地址
      if (res.code == 200) {
        this.videoForm.showVideoPath = base.httpCtx + res.data.videoUrl
        this.poster = res.data.videoCover
        this.addForm.videoCover = res.data.videoCover
        this.posterView = base.httpCtx + res.data.videoCover + '?' + 't=' + new Date().getTime()
        this.videoPath = res.data.videoUrl
        this.playTime = res.data.videoLength
        console.log(this.posterView)
        // this.videoId = res.data.id
      } else {
        this.$message.error(res.msg)
      }
    },
    // 上传封面图片成功
    handleIconSuccess(res, file) {
      if (res.code == '200') {
        //this.poster = URL.createObjectURL(file.raw)
        this.poster = res.data.saveUrls
        this.addForm1.videoCover = res.data.saveUrls
        var time = new Date().getMilliseconds()
        this.posterView = base.httpCtx + res.data.saveUrls + '?' + 't=' + time
        // console.log(this.posterView)
      } else {
        this.$message.error(res.msg)
      }
    },
    handleIconSuccess2(res, file) {
      console.log(res)
      if (res.code == '200') {
        //this.poster = URL.createObjectURL(file.raw)
        this.poster = res.data.saveUrls
        this.addForm2.videoCover = res.data.saveUrls
        var time = new Date().getMilliseconds()
        this.posterView2 = base.httpCtx + res.data.saveUrls + '?' + 't=' + time
        // console.log(this.posterView)
      } else {
        this.$message.error(res.msg)
      }
    },
    //
    cancal(){
           this.addFormVisible1 = false
    },
    doFilter(){
      this.getData()
    }
  },
}
</script>
<style scoped>
.box-second {
  width: 100%;
  height: 100%;
  position: relative;
}
.title {
  width: 100%;
  height: 6vh;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 0 1vw;
  justify-content: space-between;
}
.main {
  width: 100%;
  height: calc(100% - 6vh);
  position: relative;
  display: flex;
  padding: 0 1vw 0.5vw;
  overflow: hidden;
  flex-wrap: wrap;
}
.main-con {
  width: 100%;
  height: calc(100% - 5vh);
  position: relative;
  background: rgba(255, 255, 255, 0.4);
  overflow: auto;
}
.grid-content {
  width: 100%;
  height: 40vh;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 1vh 3vh;
  align-content: flex-start;
}
.grid-content .txt {
  width: 100%;
  height: 4vh;
  position: relative;
  text-align: center;
  line-height: 4vh;
}
.grid-content .center {
  text-align: left;
}
.grid-content .txtArea {
  width: 100%;
  height: 6vh;
  position: relative;
  text-align: left;
  line-height: 3vh;
}
.grid-content .ctl {
  width: 100%;
  height: 4vh;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
/* 图片 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>

<style>
.grid-content .el-checkbox__label {
  display: none;
}
@import '../../assets/css/common.css';
</style>